// extracted by mini-css-extract-plugin
export default {"num":"timer_num__Je2Yx","_button":"timer__button__V-myy","content":"timer_content__Xc56h"};